<section>
  <div class="d-flex report-template">
    <div>
      <button mat-icon-button color="primary" [matTooltip]="'reportnewPreview.Back' | translate" matTooltipPosition="right" (click)='cancel()'>
        <mat-icon>arrow_back</mat-icon>
      </button>
    </div>
    <div class="d-flex ml-2"> 
      <button mat-icon-button color="primary">
        <mat-icon class="icon-file">description</mat-icon>
      </button>
      <div>
        <span class="template-name">{{'reportnewPreview.templateName' | translate}}</span>
        <span class="last-saved">{{'reportnewPreview.saved' | translate}} {{designService.getTemplateLastSaved() | timeago}}</span>
        <div  class="spinner-small"><osc-utils-spinner [spinnerId]="designService.saveSpinnerId" [small]="true"></osc-utils-spinner></div>
        <h6>{{templateName}}</h6>
      </div>      
    </div>
    <div class="d-flex right-section">
      <div class="report-type ml-4" *ngIf="!isVisol">
        <span class="report-type__label">{{'reportnewPreview.reportType' | translate}}</span>
        <h6 [matTooltip]="'objects.' + reportType | translate" matTooltipPosition="below">{{ 'objects.' + reportType | translate }}</h6>
      </div>
      <div class="equipment-type ml-4" *ngIf="!isVisol">
        <span class="equipment-type__label">{{'reportnewPreview.equipmentType' | translate}}</span>
        <h6 [matTooltip]="equipmentType | equipmentTypes" matTooltipPosition="below">{{(equipmentType?.length>13)? (equipmentType | equipmentTypes | slice:0:20)+'..':(equipmentType | equipmentTypes)}}</h6>
      </div>
      <div class="application ml-4">
        <span class="application__label">{{'reportnewPreview.application' | translate}}</span>
        <mat-label>{{'reportnewPreview.application' | translate}}</mat-label>
        <mat-select [(ngModel)]="application" (ngModelChange)="changeApplication()" disableOptionCentering>
          <mat-option *ngFor="let application of applications" [value]="application">
            {{application}}
          </mat-option>
        </mat-select>
      </div>
      <div class="ml-4 pr-3" *ngIf="application === 'ViSOL'">
        <span class="application__label">{{'reportnewPreview.inspectionTemplates' | translate}}</span>
        <mat-label>{{'reportnewPreview.selectTemplates' | translate}}</mat-label>
        <mat-select #inspectors [formControl]="subjectModelsCtrl" multiple
                  [disableOptionCentering]="true" (selectionChange)="changeTargetSubjectModels()">
        <mat-select-trigger>
          {{subjectModelsCtrl.value.length > 0 ? getSortedSubjectModels()[0].subjectModel.name : ''}}
          <span *ngIf="subjectModelsCtrl.value.length > 1">
            (+{{subjectModelsCtrl.value.length - 1}} others)
          </span>
        </mat-select-trigger>
        <mat-option [ngClass]="{'is-disabled-model': !subjectModel.subjectModel.isValid}" *ngFor="let subjectModel of subjectModelsMaster" [value]="subjectModel">
          <span class="option-label-overflow" [matTooltip]="subjectModel.subjectModel.name" matTooltipPosition="above" matTooltipClass="tooltip-overflow">
            {{subjectModel.subjectModel.name}}
          </span>
        </mat-option>
      </mat-select>
      </div>
    </div>    
  </div>
</section>
<mat-divider class="mb-1"></mat-divider>
<section class="d-flex toolbar mb-1">
  <div class="vw-85">
    <button mat-icon-button color="primary" class="mx-1" [matTooltip]="'reportnewPreview.copyElements' | translate" matTooltipPosition="right"
      (click)="copySelectedElements()"
      [disabled]="!selectedPropPanels || selectedPropPanels.length === 0">
      <mat-icon>file_copy</mat-icon>
    </button>
    <button mat-icon-button color="primary" class="mx-1" [matTooltip]="'reportnewPreview.cutElements' | translate"  matTooltipPosition="right"
      (click)="cutSelectedElements()"
      [disabled]="!selectedPropPanels || selectedPropPanels.length === 0">
      <mat-icon>content_cut</mat-icon>
    </button>
    
    <button mat-icon-button color="primary" class="mx-1" [matTooltip]="'reportnewPreview.pasteElements' | translate" matTooltipPosition="right"
      (click)="PasteCopiedElements()"
      [disabled]="selectedElements?.length === 0">
      <mat-icon>content_paste</mat-icon>
    </button>
    <button mat-icon-button color="primary" class="mx-1" [matTooltip]="'reportnewPreview.deleteSelection' | translate" matTooltipPosition="right"
    [disabled]="!selectedPropPanels || selectedPropPanels.length === 0" (click)="deleteSelectedElement()"
    >
    <mat-icon>delete</mat-icon>
    </button>
    <button *ngIf="isVisol" mat-flat-button color="primary" class="mr-2" (click)='openImageUploadDialog()'>
      <mat-icon class="mr-1">add</mat-icon>{{'reportnewPreview.images' | translate}}
    </button>
    <button mat-stroked-button class="mx-1 template-settings" color="primary" (click)="openTemplateSettings()" [matTooltip]="'reportnewPreview.templatesettings' | translate" matTooltipPosition="right">
      <mat-icon>settings</mat-icon>{{'reportnewPreview.templatesettings' | translate}}
    </button>
    <mat-divider [vertical]="true" class="toolbar__divider my-1"></mat-divider>
    <button mat-icon-button class="mx-1" color="primary" [matTooltip]="'reportnewPreview.Undo' | translate" matTooltipPosition="right"
            (click)="undoElement()" [disabled]="designService.templateForUndo.length == 0" [ngClass]="{'btn-disabled': designService.templateForUndo.length == 0}">
            <mat-icon>undo</mat-icon>
    </button>
    <button mat-icon-button class="mx-1" color="primary" [matTooltip]="'reportnewPreview.Redo' | translate" matTooltipPosition="right"
            (click)="redoElement()" [disabled]="designService.templateForRedo.length === 0" [ngClass]="{'btn-disabled': designService.templateForRedo.length === 0}">
            <mat-icon>redo</mat-icon>
    </button>
    <mat-divider [vertical]="true" class="toolbar__divider my-1"></mat-divider>
    <button mat-icon-button color="primary" class="icon-save mx-1" (click)="openSaveDialog()" [matTooltip]="'reportnewPreview.savetemplate' | translate"
      matTooltipPosition="right" [disabled]="saveDisabled()" [ngClass]="{'btn-disabled': saveDisabled()}">
      <mat-icon>save</mat-icon>
    </button>
    <button mat-button color="primary"  (click)="designService.checkedRuler = !designService.checkedRuler">
      <i class="fas fa-ruler-vertical fa-lg"></i><span class="ruler">{{designService.checkedRuler ? ('reportnewPreview.hideRuler' | translate) : ('reportnewPreview.showRuler' | translate) }}</span>
    </button>
    <button mat-button color="primary" style="margin-left: -8px;" (click)="showPages = !showPages">
      <mat-icon>format_list_bulleted</mat-icon><span class="pages">{{showPages? ('reportnewPreview.hidePages' | translate) : ('reportnewPreview.showPages' | translate) }}</span>
    </button>
    <button mat-stroked-button color="primary" class="mx-1" [matMenuTriggerFor]="zoom">
      <mat-icon style="margin-left: -8px;">keyboard_arrow_down</mat-icon>{{zoomOptionClicked}}
    </button>
    <mat-menu #zoom="matMenu">
      <button mat-menu-item (click)="onZoomClick(option)" *ngFor="let option of zoomOptions">{{option.name}}</button>
    </mat-menu>
    <button mat-stroked-button color="primary" class="add-element ml-3" [matMenuTriggerFor]="menu">
      <mat-icon>add</mat-icon>Add Element<mat-icon class="pl-3">arrow_drop_down</mat-icon>
    </button>
    <mat-menu #menu="matMenu" class="abcde">
      <ng-template [ngTemplateOutlet]="addElementMenu"></ng-template>
    </mat-menu>
  </div>
  <div class="vw-15"> 
    <button mat-stroked-button color="primary" class="test-device mr-3 float-right">
      <mat-icon>remove_red_eye</mat-icon>{{'reportnewPreview.templateOnDevices' | translate}}
    </button>
  </div>
</section>
<mat-divider></mat-divider>
<div class="validate-error" [ngClass]="{'scroll': isScroll()}">
  <div class="validate-error-title" *ngFor="let error of validateErrorList"
     (click)="onClickErrorList($event, error)" [style.height]="getErrorListHeight(error.validationErrorMessage.length)">
    <mat-icon class="error-icon">report_problem</mat-icon>
    <span class="list-title" *ngIf="error.pageIndex !== undefined">{{'reportnewPreview.page' | translate}} : {{error.pageIndex + 1}}</span>
    <span class="list-title" *ngIf="error.pageIndex === undefined && error.location">{{error.location}}</span>
    <span class="list-title">{{'reportnewPreview.type' | translate}} : {{'objects.' +error.type | translate}}</span>
    <div>
      <div class="validate-error-message" *ngFor="let message of error.validationErrorMessage">
        <span class="list-message" *ngIf="message">{{ 'objects.' +message.name | translate }} : {{ 'objects.errormessage_' +message.errorMessage | translate }}</span><br>
      </div>
    </div>
  </div>
</div>
<div class="d-flex report-preview-container">
  <div class="page-screen" *ngIf="showPages && zoomOptionClicked =='100%'" id="pageScreenScroll">
    <div class="mt-1 page-screen__header">
      <span class="ml-2">{{'reportnewPreview.pages' | translate}}</span>
      <mat-icon (click)="showPages = !showPages">close</mat-icon>
    </div>
    <div class="mx-1">
      <ng-container *ngFor="let image of designService.pageScreens; let i = index">
        <div class="row px-4 py-4" [ngClass]="{'page-screen-background': designService.getViewPageId() === image.pageId }" (click)="clickPage(i)">
          <span class="mr-1 page-screen__number">{{i + 1}}</span>
          <img [src]="image.imageSrc" [ngClass]="{'page-screen-outline': designService.getViewPageId() === image.pageId }" class="page-screen__image">
        </div>   
      </ng-container>
    </div>
  </div>
  <div class="flex-grow-1">
    <div class="report-content" (click)="onClick($event)">
      <div class="report-preview" id="pageScroll" (scroll)="scrollEvent($event)">
        <app-report-page-container class="report-page-outer" (mousedown)="onMouseDown($event)" *ngFor="let pageKey of reportPageKeys" [pageKey]="pageKey" [isNewApp]="true">
          <ng-template [ngTemplateOutlet]="addElementMenu"></ng-template>
        </app-report-page-container>
      </div>
    </div>
  </div>

  <aside class="property-preview-panel" [hidden] ="hideContentDesign">
      <app-property-new-preview #property></app-property-new-preview>   
  </aside>
</div>
<div class="d-flex report-preview-container">

</div>
<ng-template #addElementMenu>
    <div class="add-element-menu">{{'reportnewPreview.addElement' | translate}}</div>
    <button mat-menu-item (click)="onSelectObjectMenu('page', 'add')" [disabled]="!permissionForActions['page']['add']"><mat-icon>crop_portrait_fill</mat-icon>{{'reportnewPreview.page' | translate}}</button>
    <button mat-menu-item (click)="onSelectObjectMenu('section', 'draw')" [disabled]="!permissionForActions['section']['draw']"><mat-icon>extension</mat-icon>{{'reportnewPreview.section' | translate}}</button>
    <button mat-menu-item (click)="onSelectObjectMenu('text', 'draw')" [disabled]="!permissionForActions['text']['draw']"><mat-icon>title</mat-icon>{{'reportnewPreview.text' | translate}}</button>
    <button mat-menu-item (click)="onSelectObjectMenu('line', 'draw')" [disabled]="!permissionForActions['line']['draw']"><mat-icon>remove</mat-icon>{{'reportnewPreview.line' | translate}}</button>
    <button mat-menu-item (click)="onSelectObjectMenu('image', 'draw')" [disabled]="!permissionForActions['image']['draw']"><mat-icon>image</mat-icon>{{'reportnewPreview.image' | translate}}</button>
    <button mat-menu-item (click)="onSelectObjectMenu('rectangle', 'draw')" [disabled]="!permissionForActions['rectangle']['draw']"><mat-icon>crop_7_5</mat-icon>{{'reportnewPreview.rectangle' | translate}}</button>
    <button mat-menu-item (click)="onSelectObjectMenu('interactiveIso', 'draw')" *ngIf="!isVisol" [disabled]="!permissionForActions['interactiveIso']['draw']"><mat-icon>layers</mat-icon>{{'reportnewPreview.interactiveISO' | translate}}</button>
    <button mat-menu-item (click)="onSelectObjectMenu('table', 'draw')" *ngIf="!isVisol" [disabled]="!permissionForActions['table']['draw']"><mat-icon>grid_on</mat-icon>{{'reportnewPreview.table' | translate}}</button>
    <button mat-menu-item (click)="onSelectObjectMenu('measurementPoint', 'draw')" *ngIf='!isVisol || getApplication() === "IPM"' [disabled]="!permissionForActions['measurementPoint']['draw']"><mat-icon>table_chart</mat-icon>{{'reportnewPreview.measurementResults' | translate}}</button>
    <button mat-menu-item (click)="onSelectObjectMenu('visualEvents', 'draw')" *ngIf='!isVisol || getApplication() === "IPM"' [disabled]="!permissionForActions['visualEvents']['draw']"><mat-icon>photo_album</mat-icon>{{'reportnewPreview.visualEvents' | translate}}</button>
    <button mat-menu-item (click)="onSelectObjectMenu('signature', 'draw')" *ngIf="!isVisol"[disabled]="!permissionForActions['signature']['draw']"><i class="fas fa-signature"></i><span style="margin-left: 21px;">{{'reportnewPreview.signature' | translate}}</span></button>
    <button mat-menu-item (click)="onSelectObjectMenu('summary', 'draw')" *ngIf="isVisol" [disabled]="!permissionForActions['summary']['draw']"><mat-icon>grid_on</mat-icon>{{'reportnewPreview.summaryTable' | translate}}</button>
    <button mat-menu-item (click)="onSelectObjectMenu('picture', 'draw')" *ngIf="isVisol" [disabled]="!permissionForActions['picture']['draw']"><mat-icon>grid_on</mat-icon>{{'reportnewPreview.pictureTable' | translate}}</button>
    <button mat-menu-item (click)="onSelectObjectMenu('dataPlate', 'draw')" *ngIf="isVisol" [disabled]="!permissionForActions['dataPlate']['draw']"><mat-icon>grid_on</mat-icon>{{'reportnewPreview.dataPlate' | translate}}</button>
    <button mat-menu-item (click)="onSelectObjectMenu('dropDownList', 'draw')" *ngIf='getApplication() === "IPM"' [disabled]="!permissionForActions['dropDownList']['draw']"><mat-icon>list_alt</mat-icon>{{'reportnewPreview.dropdownList' | translate}}</button>
    <mat-divider></mat-divider>
    <div class="create-element mt-2">
      <button (click)="onSelectObjectMenu('customElement', 'draw', 'addCustomElement')" mat-flat-button color="primary" style="font-size: 10px;">{{'reportnewPreview.newcustomelement' | translate}}
      </button>
    </div>
    <ng-container *ngFor="let elementdetail of designService.reportCustomTemplates">
      <button (click)="onSelectObjectMenu('customElement', 'draw', 'drawCustomElement', elementdetail.id, elementdetail.name)" mat-menu-item><mat-icon>ballot</mat-icon>{{elementdetail.name}}<span class="badge ml-1 custom-element">{{'reportnewPreview.customelement' | translate}}</span><mat-icon [matTooltip]="'reportnewPreview.Delete' | translate" color="warn" (click)="deleteCustomElement(elementdetail.id)">delete</mat-icon></button>
    </ng-container>  
</ng-template>
